const apiConfig = {
	//BASE_URL: "https://localhost:5001/",
	// BASE_URL: "http://20.0.89.149:7001/",
	//BASE_URL: "https://fcapi.ej-software.co.uk/",
	BASE_URL: "https://portal-api.freshcheck.co.uk/",
};

export default apiConfig;
